<template>
	<div class="answer-cnt">
		<ja-card
			:inline="true"
			:selected="selectedAnswer === true"
			:aria-checked="(selectedAnswer === true).toString()"
			role="radio"
			@click.native="selectAnswer(true)"
		>
			{{ $t('true') }}
		</ja-card>
		<ja-card
			:inline="true"
			:selected="selectedAnswer === false"
			:aria-checked="(selectedAnswer === false).toString()"
			role="radio"
			@click.native="selectAnswer(false)"
		>
			{{ $t('false') }}
		</ja-card>
	</div>
</template>
<script>
import Card from '@/components/ui/Card';
export default {
	components: {
		jaCard: Card
	},
	props: {
		selectedAnswer: {
			type: Boolean,
			default: null
		}
	},
	methods: {
		selectAnswer(answer) {
			this.$emit('answerSelected', {
				answer: answer,
				text: answer.toString()
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.answer-cnt {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;

	> .card {
		width: 50%;

		&:first-child {
			margin-right: 16px;
		}
	}
}
</style>
